import sortPriorityFiats from '@/helpers/sortPriorityFiats';

import Api from '../api';

export default {
  getAvailableCryptoCurrencies () {
    return this._getPublic('cryptos');
  },
  getAvailableFiatCurrencies () {
    return this._getPublic('fiats')
      .then((unsortedFiatList) => sortPriorityFiats(unsortedFiatList));
  },
  getHistoricData (market, cryptoCode, fiatCode, timePeriod) {
    return this._getPublic(`price/${market}/${cryptoCode}/${fiatCode}/${timePeriod}`);
  },
  getDetails (market, cryptoCode, fiatCode) {
    return this._getPublic(`details/${market}/${cryptoCode}/${fiatCode}`)
      // eslint-disable-next-line camelcase
      .then(({ market_info, other_cryptos }) => {
        return {
          marketInfo: market_info,
          otherCryptosList: other_cryptos,
        };
      });
  },
  getDescription (cryptoCode, language) {
    return this._getPublic(`desc/${cryptoCode}/${language}`);
  },
  getPrice (market, cryptoCode, fiatCode) {
    return this._getPublic(`price/${market}/${cryptoCode}/${fiatCode}`);
  },
  getAllPrices (market, fiatCode) {
    return this._getPublic(`cryptos/${market}/${fiatCode}`);
  },
  getHistoricalData (market, fiatCode, cryptoCode, period) {
    return this._getPublic(`price/${market}/${cryptoCode}/${fiatCode}/${period}`);
  },
  _getPublic (path) {
    return this._getApiWithoutAuthorization()
      .get(this._getPublicApiUrl(path))
      .then(({ data }) => data);
  },
  _getPublicApiUrl (path) {
    const rootUrl = SEO_PRICES_API_URL; // eslint-disable-line no-undef

    return `${rootUrl}/${path}`;
  },
  _getApiWithoutAuthorization () {
    const instance = Api();
    instance.interceptors.request.use(function (config) {
      if (config.headers.Authorization) {
        delete config.headers.Authorization;
      }

      return config;
    });

    instance.interceptors.request.handlers.reverse();

    return instance;
  },
};
